import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function PlusIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_4_13)">
        <path
          d="M18.5 3.5C18.5 2.11929 17.3807 1 16 1C14.6193 1 13.5 2.11929 13.5 3.5V28.5C13.5 29.8807 14.6193 31 16 31C17.3807 31 18.5 29.8807 18.5 28.5V3.5Z"
          fill="currentColor"
        />
        <path
          d="M3.5 13.5C2.11929 13.5 1 14.6193 1 16C1 17.3807 2.11929 18.5 3.5 18.5H28.5C29.8807 18.5 31 17.3807 31 16C31 14.6193 29.8807 13.5 28.5 13.5L3.5 13.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_13">
          <rect width="30" height="30" fill="white" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
